import { Elastic, Sine, TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "../Application";
import * as Constants from "../Data/Constants";
import * as SFX from "../Data/SoundEffectKeys";

export class SelectionProgress extends PIXI.Container {
    private static NODE_START: number = -275;
    private static NODE_SPACING: number = 69.5;
    private static NODE_COUNT: number = 8;

    private _activeIndex: number;

    private _bg: PIXI.Sprite;
    private _balloon: PIXI.Sprite;
    private _tent: PIXI.Sprite;
    private _checkmarks: PIXI.Sprite[];

    private _timeline: TimelineLite | undefined;

    constructor(pStartIndex: number = 0) {
        super();
        this._activeIndex = pStartIndex;

        this._bg = HLF.PixiUtils.makeSprite("select-progress-base", Constants.SPRITESHEET_UI);
        this.addChild(this._bg);

        this._tent = HLF.PixiUtils.makeSprite("select-progress-tent", Constants.SPRITESHEET_UI);
        this._tent.anchor.set(0.5, 0.55);
        this._tent.position.set(this.getNodeX(SelectionProgress.NODE_COUNT), 0);
        this.addChild(this._tent);

        this._checkmarks = new Array<PIXI.Sprite>(SelectionProgress.NODE_COUNT);
        for (let i = 0; i < this._checkmarks.length; ++i) {
            this._checkmarks[i] = HLF.PixiUtils.makeSprite("select-progress-check", Constants.SPRITESHEET_UI);
            this._checkmarks[i].position.set(this.getNodeX(i), 0);
            this._checkmarks[i].anchor.set(0.5, 0.65);
            this._checkmarks[i].visible = this._activeIndex > i;
            this.addChild(this._checkmarks[i]);
        }

        this._balloon = HLF.PixiUtils.makeSprite("select-progress-balloon", Constants.SPRITESHEET_UI);
        this._balloon.position.set(this.getNodeX(pStartIndex), 0);
        this.addChild(this._balloon);
    }

    public destroy(pOptions: boolean | PIXI.DestroyOptions = { children: true }): void {
        if (this._timeline !== undefined) { this._timeline.kill(); }
    }

    public animateBalloon(): void {
        this._checkmarks[this._activeIndex].alpha = 0;
        this._checkmarks[this._activeIndex].scale.set(4);
        this._checkmarks[this._activeIndex].visible = true;

        Application.instance.audio.play(SFX.MINIMAP_MOVE, 1, false, HLF.AudioCategory.SFX);
        if (this._timeline !== undefined) { this._timeline.kill(); }
        this._timeline = new TimelineLite();
        this._timeline.to(this._balloon, 0.75, {
            x: this.getNodeX(this._activeIndex + 1),
            ease: Sine.easeInOut,
        }, 0);
        this._timeline.to(this._checkmarks[this._activeIndex], 0.5, {
            alpha: 1,
            ease: Sine.easeInOut,
        }, 0.5);
        this._timeline.to(this._checkmarks[this._activeIndex].scale, 1.25, {
            x: 1,
            y: 1,
            ease: Elastic.easeOut,
        }, 0.5);
    }

    private getNodeX(pIndex: number): number {
        return SelectionProgress.NODE_START + SelectionProgress.NODE_SPACING * pIndex;
    }
}
